import { defineStyle } from '@chakra-ui/react';

const style = defineStyle({
  root: {
    py: '5px',
    px: '10px',
    '.documentListSkeleton': {
      height: '1px',
    },
    '.documentListSkeleton1': {
      height: '35px',
      width: '35px',
    },
    '.documentListSkeletonText': {
      noOfLines: 1,
      w: '300px',
    },
    '.documentListSkeletonText1': {
      noOfLines: 1,
    },
    '.documentListSkeletonText2': {
      noOfLines: 1,
      width: '100px',
    },
    '.documentListFlex': {
      py: '20px',
      px: '10px',
      placeItems: 'center',
    },
    '.documentListFlex1': {
      gap: '10px',
      px: '15px',
      py: '10px',
    },
    '.documentListStack': {
      w: '100px',
      alignSelf: 'center',
    },
  },
});

export default style;
